import { render, staticRenderFns } from "./dealerModel.vue?vue&type=template&id=45839050&scoped=true"
import script from "./dealerModel.vue?vue&type=script&lang=js"
export * from "./dealerModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45839050",
  null
  
)

export default component.exports